export const initialValues = {
  sumTotalArea: -1,
  sumLevyLand: -1,
  sumUnpaidLevyLand: -1,
  conservationAreas: [],
  sumGgfArea: -1,
  sumGgfAmount: -1,
  sumSbbArea: -1,
  sumSbbAmount: -1,
  sumGsmArea: -1,
  sumGsmAmount: -1,
  sumNvArea: -1,
  sumNvAmount: -1,
  sumSrfArea: -1,
  sumSrfAmount: -1,
  sumMflArea: -1,
  sumMflAmount: -1,
  sumScatteredTreesCount: -1,
  sumScatteredTreesAmount: -1,
  anyIntPrecincts: null,
  anyIntCrownLand: null,
  anyIntNativeVegRegulationsArea: null,
  anyIntSalvageAndTranslocationArea: null
}

const getSumOfParcelProperty = (
  parcelData: any,
  parcelsSelected: string[],
  propName: string,
  decimalPlaces: number
): number => {
  if (!parcelsSelected.length) {
    return -1
  }
  return parseFloat(
    parcelsSelected
      .filter((parcelKey: string) => propName in parcelData[parcelKey])
      .map((parcelKey: string) => parcelData[parcelKey][propName])
      .reduce((a, b) => a + b, 0)
      .toFixed(decimalPlaces)
  )
}

const getAggregateConservationAreas = (parcelData: any, parcelsSelected: string[]) => {
  let aggConsAreas: any = {}
  parcelsSelected.forEach((parcelKey: string) => {
    const parcelConsAreas = parcelData[parcelKey]['conservationAreas']
    parcelConsAreas.forEach((parcelConsArea: any[]) => {
      const consAreaIdTypeKey = `${parcelConsArea[0]}:${parcelConsArea[1]}`
      if (Object.keys(aggConsAreas).indexOf(consAreaIdTypeKey) !== -1) {
        aggConsAreas[consAreaIdTypeKey] = aggConsAreas[consAreaIdTypeKey] + parcelConsArea[2]
      } else {
        aggConsAreas[consAreaIdTypeKey] = parcelConsArea[2]
      }
    })
  })
  return Object.keys(aggConsAreas).map(x => x.split(':').concat(aggConsAreas[x]))
}

export const getAnyTrueParcelProperty = (parcelData: any, parcelsSelected: string[], propName: string) => {
  if (!parcelsSelected.length) {
    return null
  }
  return parcelsSelected.filter((parcelKey: string) => !!parcelData[parcelKey][propName]).length > 0
}

export const computeAggregates = (parcelData: any, parcelsSelected: string[]) => {
  const aggregates: any = {}
  aggregates.sumTotalArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'totalArea', 3)
  aggregates.sumLevyLand = getSumOfParcelProperty(parcelData, parcelsSelected, 'levyLand', 3)
  aggregates.sumUnpaidLevyLand = getSumOfParcelProperty(parcelData, parcelsSelected, 'unpaidLevyLand', 3)
  aggregates.conservationAreas = getAggregateConservationAreas(parcelData, parcelsSelected)
  aggregates.sumGgfArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'ggfArea', 3)
  aggregates.sumGgfAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'ggfAmount', 2)
  aggregates.sumSbbArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'sbbArea', 3)
  aggregates.sumSbbAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'sbbAmount', 2)
  aggregates.sumGsmArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'gsmArea', 3)
  aggregates.sumGsmAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'gsmAmount', 2)
  aggregates.sumNvArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'nvArea', 3)
  aggregates.sumNvAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'nvAmount', 2)
  aggregates.sumSrfArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'srfArea', 3)
  aggregates.sumSrfAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'srfAmount', 2)
  aggregates.sumMflArea = getSumOfParcelProperty(parcelData, parcelsSelected, 'mflArea', 3)
  aggregates.sumMflAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'mflAmount', 2)
  aggregates.sumScatteredTreesCount = getSumOfParcelProperty(parcelData, parcelsSelected, 'scatteredTreesCount', 0)
  aggregates.sumScatteredTreesAmount = getSumOfParcelProperty(parcelData, parcelsSelected, 'scatteredTreesAmount', 2)
  aggregates.anyIntPrecincts = getAnyTrueParcelProperty(parcelData, parcelsSelected, 'intPrecincts')
  aggregates.anyIntCrownLand = getAnyTrueParcelProperty(parcelData, parcelsSelected, 'intCrownLand')
  aggregates.anyIntNativeVegRegulationsArea = getAnyTrueParcelProperty(
    parcelData,
    parcelsSelected,
    'intNativeVegRegulationsArea'
  )
  aggregates.anyIntSalvageAndTranslocationArea = getAnyTrueParcelProperty(
    parcelData,
    parcelsSelected,
    'intSalvageAndTranslocationArea'
  )
  return aggregates
}
